const globalTranslations = {
  ar: {},
  bs: {},
  'nb-NO': {
    cancel: 'avbryt',
    accept: 'bekreft',
    done: 'ferdig',
    back: 'tilbake',
    send: 'send',
    save: 'lagre',
  },
  'nn-NO': {},
  en: {
    cancel: 'cancel',
    accept: 'accept',
    done: 'done',
    back: 'back',
    send: 'send',
    save: 'save',
  },
  ku: {},
  pl: {},
  so: {},
  sq: {},
  ta: {},
  tr: {},
  ur: {},
  vi: {},
}

export { globalTranslations }
